import { Path, Svg, SvgProps } from 'react-native-svg'

export default function DeFlag(props: SvgProps) {
  return (
    <Svg width="60" height="40" viewBox="0 0 60 40" fill="none" {...props}>
      <Path d="M60 0H0V13.3333H60V0Z" fill="#000000" />
      <Path d="M60 13.3333H0V26.6666H60V13.3333Z" fill="#DD0000" />
      <Path d="M60 26.6667H0V40H60V26.6667Z" fill="#FFC400" />
    </Svg>
  )
}
